<template>
    <div class="java-page">
      <section class="page-hero">
        <div class="container">
          <div class="hero-content">
            <div class="hero-image">
              <img src="https://tsyyapi.dctechonline.cn/static/images/p3.jpg" alt="Java课程"/>
            </div>
            <div class="hero-info">
              <h1 class="page-title">Java 课程体系</h1>
              <p class="page-desc">从入门到竞赛，系统化学习Java编程语言</p>
              
              <div class="level-cards">
                <div class="level-card" v-for="(level, index) in levels" :key="index">
                  <div class="level-header">
                    <h3 class="level-title">{{ level.title }}</h3>
                    <span class="level-age">{{ level.age }}</span>
                  </div>
                  <p class="level-desc">{{ level.desc }}</p>
                </div>
              </div>
              
              <div class="cta-button">
                <button class="btn btn-primary btn-lg" @click="toClass()">
                  <span>进入Java课堂</span>
                  <span class="btn-icon">→</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="curriculum-section">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title">课程大纲</h2>
            <p class="section-subtitle">系统化的课程设计，循序渐进提升编程能力</p>
          </div>

          <div class="curriculum-grid">
            <div class="curriculum-card">
              <div class="card-header">
                <div class="card-icon">📚</div>
                <h3 class="card-title">Java入门课程</h3>
              </div>
              <ul class="curriculum-list">
                <li v-for="(item, index) in beginnerCourses" :key="index">
                  <span class="lesson-number">{{ index + 1 }}</span>
                  <span class="lesson-title">{{ item }}</span>
                </li>
              </ul>
            </div>

            <div class="curriculum-card">
              <div class="card-header advanced">
                <div class="card-icon">🚀</div>
                <h3 class="card-title">Java进阶课程</h3>
              </div>
              <ul class="curriculum-list">
                <li v-for="(item, index) in advancedCourses" :key="index">
                  <span class="lesson-number">{{ index + 1 }}</span>
                  <span class="lesson-title">{{ item }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="teachers-section">
        <div class="container">
          <div class="teachers-content">
            <div class="teachers-text">
              <h2 class="section-title text-left">教学师资</h2>
              <p class="teachers-desc">
                团队教师都是来自于985高校计算机专业毕业的在线编程老师，为孩子提供专业指导和支持，有丰富的教学经验。
              </p>
              <p class="teachers-highlight">
                首席讲师硕士毕业于上海交通大学，在IT互联网行业深耕多年。
              </p>
              <div class="teacher-tags">
                <span class="tag">985高校</span>
                <span class="tag">计算机专业</span>
                <span class="tag">丰富经验</span>
              </div>
            </div>
            <div class="teachers-image">
              <img src="/images/teach.jpg" alt="教学团队"/>
            </div>
          </div>
        </div>
      </section>

      <section class="cta-section">
        <div class="container">
          <div class="cta-content">
            <div class="cta-image">
              <img src="/images/back2.jpg" alt="开始学习"/>
            </div>
            <div class="cta-text">
              <h2 class="cta-title">我要上课</h2>
              <p class="cta-desc">联系课程顾问获取课程价格以及上课方式</p>
              <div class="cta-qr">
                <img src="https://tsyyapi.dctechonline.cn/static/images/head.jpg" alt="扫码咨询"/>
              </div>
            </div>
          </div>
        </div>
      </section>

      <bottom></bottom>
    </div>
</template>

<script>
import bottom from '@/components/bottom.vue'

export default{
    components:{
        bottom
    },
    data() {
      return {
        levels: [
          { title: '入门级', age: '8-10岁', desc: '讲解Java语言的基础知识，变量，条件，循环，数组等概念。课堂讲解+课后练习相结合' },
          { title: '进阶级', age: '10-15岁', desc: '讲解Java语言的高级特性，面向对象的特性。课堂讲解+课后练习相结合' },
          { title: '比赛级', age: '10岁+', desc: '针对USACO等国内外竞赛，应对AP考试的教学' }
        ],
        beginnerCourses: [
          '认识编程和Java',
          '变量和数据类型',
          '输入和输出',
          '条件语句',
          '循环语句',
          '函数和过程',
          '数组和列表',
          '图像显示',
          '进一步学习条件语句',
          '进一步学习循环语句',
          '进一步学习函数',
          '综合项目挑战'
        ],
        advancedCourses: [
          '变量，条件，循环的综合应用',
          '可变列表',
          '哈希表',
          '集合类的综合应用',
          '递归函数的应用',
          '类的基本概念',
          '类的继承',
          '类的综合应用',
          '综合应用（1）',
          '综合应用（2）'
        ]
      }
    },
    methods:{
        toClass(){
            this.$router.push('/java-class')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';
@import '../styles/mixins.scss';

.java-page {
  background: $bg-secondary;
}

.page-hero {
  padding: 120px 0 80px;
  background: white;
  
  @include responsive(md) {
    padding: 100px 0 60px;
  }
}

.hero-content {
  display: flex;
  align-items: flex-start;
  gap: 60px;
  
  @include responsive(md) {
    flex-direction: column;
    gap: 40px;
  }
}

.hero-image {
  flex: 0 0 40%;
  
  img {
    width: 100%;
    border-radius: $border-radius-xl;
    box-shadow: $shadow-lg;
  }
  
  @include responsive(md) {
    flex: 1;
    width: 100%;
  }
}

.hero-info {
  flex: 1;
}

.page-title {
  font-size: 42px;
  font-weight: 800;
  color: $text-primary;
  margin-bottom: 12px;
  
  @include responsive(md) {
    font-size: 32px;
  }
}

.page-desc {
  font-size: 18px;
  color: $text-secondary;
  margin-bottom: 32px;
  
  @include responsive(md) {
    font-size: 16px;
  }
}

.level-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 32px;
  
  @include responsive(md) {
    grid-template-columns: 1fr;
  }
}

.level-card {
  padding: 24px;
  background: $bg-secondary;
  border-radius: $border-radius-lg;
  border: 1px solid transparent;
  transition: all $transition;
  
  &:hover {
    border-color: rgba($primary-color, 0.3);
    box-shadow: $shadow;
    transform: translateY(-4px);
  }
}

.level-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.level-title {
  font-size: 18px;
  font-weight: 600;
  color: $text-primary;
}

.level-age {
  padding: 4px 12px;
  background: $bg-gradient;
  color: white;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.level-desc {
  font-size: 14px;
  color: $text-secondary;
  line-height: 1.6;
}

.cta-button {
  margin-top: 24px;
  
  .btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 14px 32px;
    font-size: 16px;
    
    .btn-icon {
      transition: transform $transition;
    }
    
    &:hover .btn-icon {
      transform: translateX(4px);
    }
  }
}

.curriculum-section {
  padding: 80px 0;
  background: $bg-secondary;
  
  @include responsive(md) {
    padding: 60px 0;
  }
}

.section-header {
  text-align: center;
  margin-bottom: 48px;
}

.section-title {
  font-size: 36px;
  font-weight: 700;
  color: $text-primary;
  margin-bottom: 12px;
  
  @include responsive(md) {
    font-size: 28px;
  }
  
  &.text-left {
    text-align: left;
  }
}

.section-subtitle {
  font-size: 16px;
  color: $text-secondary;
}

.curriculum-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  
  @include responsive(md) {
    grid-template-columns: 1fr;
  }
}

.curriculum-card {
  background: white;
  border-radius: $border-radius-lg;
  overflow: hidden;
  box-shadow: $shadow;
  
  .card-header {
    padding: 24px;
    background: $bg-gradient;
    display: flex;
    align-items: center;
    gap: 12px;
    
    &.advanced {
      background: linear-gradient(135deg, $secondary-color 0%, #4f46e5 100%);
    }
    
    .card-icon {
      font-size: 28px;
    }
    
    .card-title {
      font-size: 20px;
      font-weight: 600;
      color: white;
      margin: 0;
    }
  }
}

.curriculum-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 500px;
  overflow-y: auto;
  
  @include scroll-style;
  
  li {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 14px 24px;
    border-bottom: 1px solid $border-color;
    transition: all $transition-fast;
    
    &:last-child {
      border-bottom: none;
    }
    
    &:hover {
      background: rgba($primary-color, 0.05);
      padding-left: 32px;
    }
  }
  
  .lesson-number {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: $bg-secondary;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    color: $text-secondary;
    flex-shrink: 0;
  }
  
  .lesson-title {
    font-size: 14px;
    color: $text-primary;
  }
}

.teachers-section {
  padding: 80px 0;
  background: white;
  
  @include responsive(md) {
    padding: 60px 0;
  }
}

.teachers-content {
  display: flex;
  align-items: center;
  gap: 60px;
  
  @include responsive(md) {
    flex-direction: column;
    gap: 40px;
  }
}

.teachers-text {
  flex: 1;
  
  .section-title {
    text-align: left;
    margin-bottom: 24px;
  }
}

.teachers-desc {
  font-size: 16px;
  color: $text-secondary;
  line-height: 1.8;
  margin-bottom: 16px;
}

.teachers-highlight {
  font-size: 16px;
  color: $primary-color;
  font-weight: 500;
  margin-bottom: 24px;
}

.teacher-tags {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.tag {
  padding: 8px 16px;
  background: rgba($primary-color, 0.1);
  color: $primary-color;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}

.teachers-image {
  flex: 1;
  
  img {
    width: 100%;
    border-radius: $border-radius-lg;
    box-shadow: $shadow-lg;
  }
}

.cta-section {
  padding: 80px 0;
  background: $bg-secondary;
  
  @include responsive(md) {
    padding: 60px 0;
  }
}

.cta-content {
  display: flex;
  align-items: center;
  gap: 60px;
  
  @include responsive(md) {
    flex-direction: column;
    gap: 40px;
  }
}

.cta-image {
  flex: 1;
  
  img {
    width: 100%;
    border-radius: $border-radius-lg;
    box-shadow: $shadow-lg;
  }
}

.cta-text {
  flex: 1;
}

.cta-title {
  font-size: 32px;
  font-weight: 700;
  color: $text-primary;
  margin-bottom: 16px;
  
  @include responsive(md) {
    font-size: 28px;
    text-align: center;
  }
}

.cta-desc {
  font-size: 16px;
  color: $text-secondary;
  margin-bottom: 24px;
  
  @include responsive(md) {
    text-align: center;
  }
}

.cta-qr {
  display: inline-block;
  padding: 16px;
  background: white;
  border-radius: $border-radius-lg;
  box-shadow: $shadow;
  
  @include responsive(md) {
    display: block;
    text-align: center;
  }
  
  img {
    max-width: 180px;
    border-radius: $border-radius;
  }
}
</style>
